import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { position } from 'polished';
import { Icon } from '@deerplusofficial/pos-components';
import { color } from '@deerplusofficial/pos-helper';

const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  color: ${color.text.title};
  ${props =>
    !props.noBorder &&
    css`
      border: 1px solid ${color.border};
    `};
`;

const Arrow = styled(Icon).attrs({ icon: 'caret-down' })`
  ${props => css`
    ${position('absolute', '50%', props.noPadding ? '0' : '10px', null, null)};
  `};
  transform: translateY(-50%);
  font-size: 18px;
  pointer-events: none;
`;

const Select = styled.select`
  appearance: none;
  border: none;
  outline: none;
  background: none transparent;
  padding: 0 30px 0 10px;
  line-height: 1.5;
  width: 100%;
  color: inherit;
`;

export default class extends PureComponent {
  static propTypes = {
    noBorder: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        value: PropTypes.string,
        disabled: PropTypes.bool,
      })
    ),
    className: PropTypes.string,
  };

  static defaultProps = {
    noBorder: false,
    options: [],
    className: '',
  };

  render() {
    const { options, noBorder, className, ...props } = this.props;

    return (
      <Container className={className} noBorder={noBorder}>
        <Select {...props}>
          {_.map(options, ({ text, value, disabled }) => (
            <option key={value} value={value} disabled={disabled}>
              {text}
            </option>
          ))}
        </Select>
        <Arrow noPadding={noBorder} />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Select/Select.js